/* Offer layout variant (Harry, Oct 31) — rolled out site-wide on every LP
   running the fall bundle offer. Works on all three markups that share the
   .pgo structure: pg-offer-general + lpj-joint-fall-offer (offerA/offerB
   boxes, delegated listeners), lpj-itch/gut/general-fall-offer, and the
   pg_fall_offer product blocks (single box, listener on the flavor strip).

   What it does to each .pgo offer box:
     1. flavor <select> dropdowns move INSIDE each bundle card — under the
        photos/save/price row; buy3 => 3 selectors, buy2 => 2, buy1 => 1
        (no "Flavors:" label). Options are CLONED from the page's own hidden
        flavor selects, so labels/language always match the page.
     2. GIFTS UNLOCKED box moves directly UNDER the Add To Cart button,
        keeping the "Refills Ship Every 4 Weeks | Stop or Cancel Anytime"
        strip right under the button.
     3. "Ships from the US" line removed; "Order today for delivery by …" kept.

   Flavor writes: the active card's dropdowns are mirrored into the page's
   own (now hidden) selects + a change event is dispatched, so the page's
   original handler updates its flv[]/variant map exactly like before —
   no matter which markup family the page uses. */
(function () {
  var CSS = '\
.pgo .pgo-fl{display:none!important}\
.pgo .pgo-flv{display:flex;gap:6px;flex-wrap:nowrap;margin:-2px 14px 12px;align-items:center}\
.pgo .pgo-flv .sw{position:relative;flex:1;min-width:0}\
.pgo .pgo-flv select{appearance:none;-webkit-appearance:none;width:100%;min-width:0;font-size:13px;font-weight:500;color:var(--ink,#0B1530);background:#fff url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 10 6\'%3E%3Cpath d=\'M1 1l4 4 4-4\' fill=\'none\' stroke=\'%230B1530\' stroke-width=\'1.5\'/%3E%3C/svg%3E") right 8px center/9px no-repeat;border:1px solid var(--line,#D5DBE5);border-radius:7px;padding:7px 24px 7px 8px;cursor:pointer}\
.pgo-card.on .pgo-flv select{border-color:rgba(27,77,177,.45)}\
.pgo .pgo-del small{display:none!important}\
@media(max-width:520px){.pgo .pgo-flv{margin:-2px 12px 10px;gap:5px}.pgo .pgo-flv select{font-size:12px;padding:6px 20px 6px 7px}}';
  var st = document.createElement('style');
  st.setAttribute('data-ig-offer-variant', '1');
  st.textContent = CSS;
  document.head.appendChild(st);

  function activeCard(box) {
    return box.querySelector('.pgo-card.on') || box.querySelector('.pgo-card');
  }
  function hiddenStrip(box) { return box.querySelector('.pgo-fl'); }
  function refSelect(box) {
    var hid = hiddenStrip(box);
    return hid ? hid.querySelector('select') : null;
  }
  /* push the ACTIVE card's dropdown values into the page's own hidden
     selects so its original change handler updates flv[]/variants */
  function mirror(box) {
    var hid = hiddenStrip(box);
    var act = activeCard(box);
    if (!hid || !act) return;
    act.querySelectorAll('.pgo-flv select').forEach(function (s) {
      var h = hid.querySelector('select[data-k="' + s.dataset.k + '"]');
      if (h && h.selectedIndex !== s.selectedIndex) {
        h.selectedIndex = s.selectedIndex;
        h.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  function cardJarCount(card) {
    var imgs = card.querySelector('.pgo-imgs');
    var m = imgs && imgs.className.match(/\bq(\d)\b/);
    if (m) return +m[1];
    var pyr = card.querySelectorAll('.pgo-imgs .pgo-pyr img');
    if (pyr.length) return pyr.length;
    return card.querySelectorAll('.pgo-imgs img.jf, .pgo-imgs img.j').length || 1;
  }
  function build(box) {
    if (!box || box.dataset.igLayout) return;
    var ref = refSelect(box);
    if (!ref) return; /* offer not initialized yet — retry */
    box.dataset.igLayout = '1';

    /* 1. per-card flavor strips — options cloned from the page's own
       hidden selects (language/order always match, EN or ES) */
    var hid = hiddenStrip(box);
    box.querySelectorAll('.pgo-card').forEach(function (card) {
      var row = card.querySelector('.pgo-row');
      if (!row || card.querySelector('.pgo-flv')) return;
      var n = cardJarCount(card);
      var strip = document.createElement('div');
      strip.className = 'pgo-flv';
      for (var k = 0; k < n; k++) {
        var sw = document.createElement('span');
        sw.className = 'sw';
        var src = hid.querySelector('select[data-k="' + k + '"]') || ref;
        var opts = '';
        for (var oi = 0; oi < src.options.length; oi++) {
          var o = src.options[oi];
          opts += '<option' + (o.selected ? ' selected' : '') + '>' + o.text + '</option>';
        }
        sw.innerHTML = '<select data-k="' + k + '" aria-label="' + (src.getAttribute('aria-label') || 'Flavor') + '">' + opts + '</select>';
        strip.appendChild(sw);
      }
      row.insertAdjacentElement('afterend', strip);
    });

    /* keep flv[] in sync: changes on the ACTIVE card write through the
       hidden selects; switching cards pushes that card's values */
    box.addEventListener('change', function (e) {
      var s = e.target;
      if (s && s.matches && s.matches('.pgo-flv select')) mirror(box);
    });
    box.addEventListener('click', function (e) {
      var c = e.target && e.target.closest ? e.target.closest('.pgo-card') : null;
      if (c && box.contains(c)) mirror(box);
    });

    /* 2. gifts box under Add To Cart — refills/cancel strip stays
       directly under the button */
    var gifts = box.querySelector('.pgo-gifts');
    var foot = box.querySelector('.pgo-foot');
    if (gifts && foot && box.querySelector('.pgo-atc')) {
      foot.parentNode.insertBefore(gifts, foot.nextSibling);
    }
    /* 3. drop "Ships from the US" */
    box.querySelectorAll('.pgo-del small').forEach(function (s) { s.remove(); });
  }
  function all() {
    ['offerA', 'offerB', 'pgOffer', 'pg-itch-offer', 'pg-gut-offer', 'pg-general-offer'].forEach(function (id) {
      build(document.getElementById(id));
    });
    document.querySelectorAll('.pgo').forEach(build);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(all, 50); });
  } else {
    setTimeout(all, 50);
  }
  /* offer boxes render async — retry briefly if empty at first pass */
  var tries = 0;
  var iv = setInterval(function () {
    all();
    var pending = [].some.call(document.querySelectorAll('.pgo'), function (b) {
      return !b.dataset.igLayout && b.querySelector('.pgo-card');
    });
    if (!pending || ++tries > 40) clearInterval(iv);
  }, 250);
})();
